import React from 'react';
import experiments from '../experiments';
import { useExpEnabled } from '../user_hooks';
import AppleSigninButton from './apple_signin_button';
import FacebookSigninButton from './facebook_signin_button';

interface Props {
  redirectTo?: string;
  isSignup?: boolean;
}

export default function ThirdPartyAuthButtons(props: Props) {
  const isExperimentEnabled = useExpEnabled(experiments.APPLE_SIGN_IN_WEB);

  return (
    <>
      <FacebookSigninButton
        isSignup={props.isSignup}
        redirectTo={props.redirectTo}
        isExperimentEnabled={isExperimentEnabled}
      />
      <AppleSigninButton
        isSignup={props.isSignup}
        redirectTo={props.redirectTo}
        isExperimentEnabled={isExperimentEnabled}
      />
    </>
  );
}
